import styled from "styled-components"
import { FONT_SIZE, COLOR, getFontContrastColor } from "../../themes"
const Style = styled.section`
  margin: 0;
  padding: 0 0 12px 10px;
  overflow: hidden;
  flex: 1 1 0px;
  scroll-behavior: smooth;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;
  -webkit-overflow-scrolling: touch;
  user-select: none;
  color: ${COLOR.BLACK_1};
  height: 100%;
  box-sizing: border-box;
  --line-height: 60px;
  --total-height: 1440px;
  * {
    user-select: none;
  }
  .timeline-content {
    overflow: visible;
    flex: 1;
    overflow-y: scroll;
    overflow-x: hidden;
    scroll-behavior: smooth;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: stretch;
    margin: 0;
    padding: 0 8px 0 0;
    -webkit-overflow-scrolling: touch;
  }
  .timeline-container {
    flex: 1;
    margin: 0;
    padding: 0;
    height: var(--total-height);
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: stretch;
    overflow: hidden;
    cursor: pointer;
  }
  .timeline-container.holiday {
    cursor: not-allowed !important;
  }
  .timeline-container:nth-child(odd) {
    background-color: ${COLOR.GRAY_13};
  }
  .row-header {
    overflow: visible;
    flex: 0;
    margin: 0 4px;
    padding: 0;
    height: var(--total-height);
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: hidden;
    min-width: 45px;
    max-width: 45px;
  }
  .row-header > .grid-line {
    border-top: none;
    font-size: 14px;
    font-family: NunitoSansRegular, 'Nunito Sans', sans-serif;
    font-weight: 400;
    color: #0A0A0A;
    line-height: 100%;
  }
  .row-header > .grid-line:first-child {
    margin-top: -6px;
  }
  .grid-line:first-child{
    border-top: none;
  }
  .grid-line {
    border-top: 1px solid #E5E5E5;
    opacity: 1;
    line-height: var(--line-height);
    height: var(--line-height);
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    transition: background-color 0.2s ease;
  }
  .timeline-container > .grid-line:not(.grid-line-border-closed):hover {
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1} !important;
    cursor: pointer;
  }
  .grid-line-closed {
    color: #0A0A0A;
  }
  .grid-line-border-closed {
    border-color: #E5E5E5;
  }
  .event-container {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    display: flex;
    padding: 0;
    margin: 0;
    flex-flow: column nowrap;
    justify-content: center;
  }
  .event-container > .resize-tool {
    width: 100%;
    cursor: ns-resize !important;
    opacity: 0;
    min-height: 2px;
    height: 2px;
    position: relative;
    padding: 0;
    margin: 0;
  }
  .event-container.dragged {
    opacity: 0.5;
  }
  .event-container.active > .event {
    box-shadow: 0 3px 6px ${COLOR.BLACK_1};
  }
  .event-container.dragging > .event {
    box-shadow: 0 3px 6px ${COLOR.BLACK_1};
    cursor: move;
  }
  .event-container.resizing > .event {
    box-shadow: 0 3px 6px ${COLOR.GRAY_5};
    cursor: ns-resize;
  }
  .event-container.active,
  .event-container.dragging,
  .event-container.resizing {
    margin: 0;
    position: absolute;
    left: 0px !important;
    right: 0px !important;
  }
  &.dragging * {
    cursor: move !important;
  }
  &.resizing * {
    cursor: ns-resize !important;
  }
  .event {
    background-color: ${({ colorTheme }) => colorTheme ? colorTheme : COLOR.GOLD_1};
    border: 1px solid ${COLOR.WHITE};
    box-sizing: border-box;
    border-radius: 4px;
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: flex-start;
    align-content: flex-start;
    margin: 0;
    padding: 7px 5px;
    width: 100%;
    height: 100%;
    cursor: pointer;
    color: ${({ colorTheme }) => getFontContrastColor(colorTheme)};
    font-size: ${FONT_SIZE.MN};
    line-spacing: 0;
    overflow: hidden;
  }
  .event > p {
    box-sizing: border-box;
    flex: 0;
    line-height: 20px;
    margin: 0;
    padding: 0 5px;
    font-weight: lighter;
    display: inline;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .event > p > span {
    font-size: ${FONT_SIZE.XXS};
    font-family: NunitoSansRegular;
  }
  .event > h4 {
    box-sizing: border-box;
    overflow: hidden;
    flex: 0;
    line-height: 20px;
    min-height: 20px;
    max-width: 100%;
    height: 20px;
    font-size: ${FONT_SIZE.XXS};
    font-family: NunitoSansSemiBold;
    margin: 0;
    padding: 0 5px;
    font-weight: bold;
    display: inline;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .event.tall {
    justify-content: flex-start;
  }
  .event.compact {
    flex-flow: row nowrap;
    align-items: baseline;
    justify-content: flex-start;
    gap: 4px;
    padding: 0 6px;
  }
  .event.compact > h4 {
    height: auto;
    min-height: 0;
    line-height: 1.1;
    font-size: 11px;
    flex: 0 1 auto;
    min-width: 0;
    padding: 0;
  }
  .event.compact > p {
    line-height: 1.1;
    font-size: 11px;
    flex: 0 0 auto;
    padding: 0;
  }
  .event.compact > p > span {
    font-size: 11px;
  }
  .now-line {
    position: absolute;
    left: 0;
    right: 0;
    height: 2px;
    background-color: #EA4335;
    z-index: 2;
    pointer-events: none;
  }
  .now-line-dot {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: #EA4335;
  }
  .animate-fade-down {
    animation-timing-function: ease-out;
    animation-duration: 140ms;
    animation-name: fade-down;
    animation-iteration-count: 1;
    animation-direction: normal;
  }
  .cursor-pointer {
    cursor: pointer !important;
  }
  .disable-mark-up-top {
    position: absolute;
    width: 100%;
    height: 0;
    background-color: ${COLOR.GRAY_13};
    cursor: not-allowed;
    top: 0;
    left: 0;
    border: none;
  }
  .disable-mark-up-bottom {
    position: absolute;
    width: 100%;
    height: 0;
    background-color: ${COLOR.GRAY_13};
    cursor: not-allowed;
    bottom: 0;
    left: 0;
    border: none;
  }
  .holiday-name-container {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    display: flex;
    padding: 0;
    margin: 0;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .holiday-name {
    display: flex;
    aline-items: center;
    width: 100%;
    font-size: ${FONT_SIZE.SM};
    background-color: ${COLOR.GRAY_17};
    padding: 20px 0 20px 20px;
  }
  @keyframes fade-down {
    0% {
      max-height: 0;
      opacity: 0;
    }
    80% {
      max-height: var(--total-height);
    }
    100% {
      opacity: 1;
    }
  }
`

export default Style

export const StyleTimelineHeader = styled.div`
  align-items: center;
  display: flex;
  height: 78px;
  justify-content: space-between;
  overflow: hidden;
  margin: 9px 0 0 47px;

  .previous-day {
    cursor: pointer;
    display: flex;
    height: calc(100% - 14px);
    margin-left: 12px;
    padding-top: 14px;
  }
  .day-in-week-container {
    display: flex;
    height: 100%;
    width: calc(100% - 40px);

    .day-in-week {
      align-items: center;
      display: flex;
      flex-direction: column;
      font-family: NunitoSansRegular;
      font-size: ${FONT_SIZE.TN};
      height: 100%;
      justify-content: flex-start;
      width: calc(100% / 7);

      &:first-child,
      &:last-child {
        .day-number {
          color: ${COLOR.GRAY_20};
        }
      }

      .day-title {
        color: ${COLOR.GRAY_20};
        margin-bottom: 4px;
      }

      .day-number {
        cursor: pointer;
        align-items: center;
        color: ${COLOR.BLACK_1};
        display: flex;
        font-size: ${FONT_SIZE.LMD};
        justify-content: center;
        height: 48px;
        margin-bottom: 7px;
        width: 48px;

        &:hover {
          background-color: ${COLOR.GRAY_21};
          border-radius: 24px;
        }

        &.today {
          background-color: transparent;
          border: 1px solid ${COLOR.BLACK_1};
          border-radius: 24px;

          &:hover {
            background-color: ${COLOR.GRAY_21};
          }
        }

        &.selected {
          background-color: ${COLOR.BLACK_1};
          border-radius: 24px;
          color: ${COLOR.WHITE};
        }

        &.today.selected:hover {
            background-color: ${COLOR.BLACK_1};
        }
      }

      &.past {
        .day-title {
          color: ${COLOR.GRAY_19};
        }

        .day-number {
          color: ${COLOR.GRAY_19};

          &.selected {
            color: ${COLOR.WHITE};
          }
        }
      }

      &.holiday {
        .day-title {
          color: ${COLOR.GRAY_20};
        }

        .day-number {
          color: ${COLOR.GRAY_20};

          &.selected {
            color: ${COLOR.WHITE};
          }
        }
      }
    }
  }
  .next-day {
    cursor: pointer;
    display: flex;
    height: calc(100% - 14px);
    padding-top: 14px;
  }
`

export const StyleTimelineMiniHeader = styled.div`
  align-items: center;
  display: flex;
  height: 165px;
  justify-content: space-between;
  overflow: hidden;
  margin: 15px 22px 0 43px;

  .day-in-week-container {
    display: flex;
    justify-content: space-between;
    height: 100%;
    width: 100%;

    .day-in-week {
      align-items: center;
      display: flex;
      flex-direction: column;
      font-family: NunitoSansRegular;
      font-size: ${FONT_SIZE.TN};
      height: 100%;
      justify-content: flex-start;

      .day-title {
        color: ${COLOR.GRAY_20};
        margin-bottom: 4px;
      }

      .day-number {
        align-items: center;
        color: ${COLOR.BLACK_1};
        display: flex;
        font-size: ${FONT_SIZE.LG};
        justify-content: center;
        height: 48px;
        margin-bottom: 7px;
        width: 48px;

        &.today {
          background-color: transparent;
          border: 1px solid ${COLOR.BLACK_1};
          border-radius: 24px;
        }

        &.selected {
          background-color: ${COLOR.BLACK_1};
          border-radius: 24px;
          color: ${COLOR.WHITE};
        }
      }
    }

    > span {
      font-family: NunitoSansBold;
      font-size: ${FONT_SIZE.XXS};
    }
  }
`
